import { httpRequest } from "@services/http"

export class CommandDeleteObjectiveJourneyStep {
    async run(engagementId: number, objectiveId: number, stepId: number) {
        const url = `${
          import.meta.env.VITE_API_PLATFORM_SERVICE_URL
        }api/v1/engagements/${engagementId}/objectives/${objectiveId}/journey-steps/${stepId}/`

        try {
            const response = await httpRequest<any>(url, {method: "DELETE"})
            return response;
        } catch (error) {
            console.error("Error deleting objective journey: ", error)
            throw error;
        }
    }
}